import * as actionType from './ActionType';

export const setStep05 = (data) => ({
  type: actionType.SET_VALUE_STEP05,
  payload: data
});
